import { CardTitle, CardText} from 'react-md';
import LoadingSpinner from '../components/LoadingSpinner';
import { Card, Typography } from '@mui/material';
import { NotificationManager } from 'react-notifications';

import MathJax from '../components/react-mathjax-preview';
import React, { Component } from 'react';

export default class FAQ extends Component {

    constructor(props){
        super(props);
        this.state = {
            pageLoading: true,
            test:"this is atest",
            FAQText:"",
            FAQData:"",
          tempUserId: ''                   
        };
        this.getFAQData = this.getFAQData.bind(this);
    }
    
    componentDidMount(){
        this.getFAQData();
    }
    getFAQData = async() =>{
       
        console.debug("getting details")
        try{
            const payload = {           
                type: 3
            };
            var abtData = [];
            let responsePromise = this.props.apiService({method: 'post',
            url: '/getDynamicData',
            data: payload});
            responsePromise.then(res => {
               
                if(res.data.data.data !== null){
                    abtData = res.data.data.text;
                    this.state.FAQData =res.data.data.text;
                    this.setState({
                        FAQData:res.data.data.text

                    });
                    
                }
                this.setState({pageLoading:false});
            }).catch(error => {
                console.error("Error when getting FAQ Data",error)
              });;
            
        }catch(err){
            NotificationManager.error(err,"Error",5000);
        }
       
    }
    render() {
        if (this.state.pageLoading) {
            return <LoadingSpinner />;
          }
        return (
           <div  className="cardPageTop">
                    <Card className="cardPageContainer"
                        style={{ position: 'relative' }} sx={{ boxShadow: 3, borderRadius: 2,marginLeft:"2%" }} >

                            <Card className='w-100 position-relative p-4' style={{ backgroundColor: '#fff', height: '90%' }} sx={{ boxShadow: 3, borderRadius: 2 }}>

                            <div className='d-flex justify-content-between align-items-end'>
                                <Typography fontSize={20} color={'primary'} fontWeight={'500'}>
                                Frequently Asked Questions
                                </Typography>
                        </div>


                            <div style={{color: '#576271', marginTop:"10px"}}>
                                
                            <MathJax  className="faq-style" math={this.state.FAQData.toString('html',null)} />
                            </div>  
                            </Card>
                    </Card>        
           
        </div>

        );
     }
}
